import React from 'react';

const MaxusPremium = ({ quoteId, fullName, makeModel, premium }) => {
  const redirectToNets = () => {
    window.location.href = process.env.REACT_APP_KRAKEN_URL + '/pay/nets/' + quoteId;
  };

  const redirectToTrustly = () => {
    window.location.href =
      process.env.REACT_APP_KRAKEN_URL + '/pay/trustly/' + quoteId;
  };

  return (
    <div className='premium-form'>
      <div className='input-row'>
        <label htmlFor='name'>Namn</label>
        <input className='input-field' id='name' readOnly value={fullName} />
      </div>
      <div className='input-row'>
        <label htmlFor='bill'>Bil</label>
        <input className='input-field' id='bill' readOnly value={makeModel} />
      </div>
      <div className='premium-box'>
        <div className='premium-box-body'>
          <div className='input-row'>
            <label htmlFor='premium'>
              Premie per
              <br />
              månad
            </label>
            <input
              className='input-field'
              readOnly
              value={`${premium} kr/månad*`}
            />
          </div>
        </div>
      </div>
      <button className='btn-draw-now' onClick={redirectToNets}>
        Betala med kort
      </button>
      <button className='btn-draw-now' onClick={redirectToTrustly}>
        Betala med autogiro
      </button>
      <div className='insurance-form__info'>
        <br />
        <p>
          * Den premie som visas bygger på ditt pris för 1 års försäkring och
          delas sedan på 12 månader. Din faktiska månadspremie beräknas på exakt
          antal dagar i månaden.
        </p>
      </div>
    </div>
  );
};

export default MaxusPremium;
